var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered m-b"},[_c('p',{staticClass:"p-sm"},[_c('b-icon',{attrs:{"icon":"sentiment_very_dissatisfied","size":"is-medium"}}),_vm._v(" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.mensagem)+"\n  ")],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b7cd214","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PortalListaVazia.vue
// module id = /foV
// module chunks = 0